import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FILTER_PRICE } from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { getCountryCurrency } from '../../helpers/currency';
import RangeSelector from '../_generic/range/RangeSelectorDynamic';

export const PriceRangeNewFilter = ({
  invert,
  inline,
  updateFilter,
  categories,
  sortBy,
  sliderValues,
  vipSearchFilter,
  priceStats,
  currentMarks,
  isNewFilterApplied = false,
  isSubCat = false,
}) => {
  const currency = getCountryCurrency();
  const marks = useMemo(() => {
    return currentMarks.reduce((out, item, index) => {
      const hasPriceStats =
        (priceStats?.price?.min !== null &&
          priceStats?.price?.min !== undefined) ||
        (priceStats?.price?.max !== null &&
          priceStats?.price?.max !== undefined);

      if (hasPriceStats) {
        out[index] = {
          label: `${currency}${item.value}`,
        };
      } else {
        // For static marks,the existing logic
        out[index] = {
          label: '##currency####price##'
            .replace('##currency##', currency)
            .replace('##price##', item.name),
        };
        if (index === currentMarks.length - 1) {
          out[index].label += '+';
        }
      }

      return out;
    }, {});
  }, [currentMarks, currency, priceStats]);

  const handleChange = (value) => {
    if (isSubCat) {
      trackEvent('newfilters_applied_subCat');
    }
    updateFilter({
      categories,
      sliderValues: value,
      sortBy,
      vipSearchFilter,
    });
  };

  const handleReset = () => {
    const resetValues = [0, currentMarks.length - 1];
    updateFilter({
      categories,
      sliderValues: resetValues,
      sortBy,
      vipSearchFilter: false,
    });
  };

  return (
    <RangeSelector
      inline={inline}
      invert={invert}
      isNewFilterApplied={isNewFilterApplied}
      label={FILTER_PRICE}
      marks={marks}
      max={currentMarks.length - 1}
      min={0}
      onChange={handleChange}
      onReset={handleReset}
      value={sliderValues}
    />
  );
};

PriceRangeNewFilter.propTypes = {
  categories: PropTypes.array.isRequired,
  currentMarks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
  inline: PropTypes.bool.isRequired,
  invert: PropTypes.bool.isRequired,
  isSubCat: PropTypes.bool,
  priceStats: PropTypes.shape({
    price: PropTypes.shape({
      max: PropTypes.number,
      min: PropTypes.number,
    }),
  }),
  sliderValues: PropTypes.array.isRequired,
  sortBy: PropTypes.string.isRequired,
  updateFilter: PropTypes.func.isRequired,
  vipSearchFilter: PropTypes.bool,
};
